<template>
  <div class="chat-window">
    <div class="topMsg">
      <div class="iconSize" @click="CloseLeft">
        <i class="el-icon-s-fold"></i>
        <p class="modeType">
          回答模型选择：
          <el-radio-group v-model="answerType" size="small" fill="rgba(72, 101, 255, 0.8)">
            <el-radio-button :label="1">知识库</el-radio-button>
            <el-radio-button :label="2">数据库</el-radio-button>
            <el-radio-button :label="3">工具库</el-radio-button>
          </el-radio-group>
        </p>
      </div>
      <p class="iconBox">
        <img :src="aiLogo" alt="" srcset="" class="logo" />
        微域大语言模型智能医助
      </p>
      <p class="iconSize" @click="CloseRight">
        <i class="el-icon-s-unfold"></i>
      </p>
    </div>
    <div class="botoom">
      <div class="chat-content" ref="chatContent" @scroll="handleScroll">
        <div class="chat-wrapper" v-for="(item, i) in chatList" :key="i">
          <div class="chat-friend" v-if="item.fromType != 'Human'">
            <div class="info-time">
              <img :src="aiLogo" alt="" />
            </div>
            <div class="chatLine">
              <div class="chat-text">
                <template v-if="loading && i == chatList.length - 1">
                  <span class="flash_cursor"></span>
                </template>
                <template v-else>
                  <pre>{{ item.content }}</pre>
                </template>
              </div>
              <div class="optionsBox" v-if="item.fromType != 'Human' && item.id" @click="optionsClick('qq')">
                <p class="text" v-if="item.actions">
                  该结果由{{ item.actions[0] }}提供
                </p>
                <p class="text">请对本次回答的结果做出评价:</p>
                <img :src="like" v-if="item.liked == null || item.liked == 1" @click="isLikeFun(i, 1)" />
                <img :src="dislike" v-if="item.liked == null || item.liked == 0" @click="isLikeFun(i, 0)" />
              </div>
            </div>
          </div>
          <div class="chat-me" v-else>
            <div class="info-time">
              <img :src="avater_user" alt="" />
            </div>
            <div class="chat-text">
              <div v-if="item.img_urls && item.img_urls.length > 0" class="imgWrap">
                <el-image fit="cover" v-for="(img, index) in item.img_urls" :key="index" :src="img" class="img"
                  :preview-src-list="item.img_urls" :z-index="2030">
                </el-image>
              </div>
              <div v-if="item.chatType == 2">
                <div class="flex align-center linehei-26 flex1">
                  <div class="over-hide1 flex1">
                    <div class="size-14 font-m eils">
                      {{ item.name }}
                    </div>
                    <span class="size-12"> {{ item.size }}MB</span>
                  </div>
                  <img :src="pdfIcon" class="width-40 height-40 mar-l-10" v-if="item.exname == 'pdf'" />
                  <img :src="wordIcon" class="width-40 height-40 mar-l-10" v-else />
                </div>
              </div>
              <pre>{{ item.content }}</pre>
            </div>
          </div>
        </div>
      </div>
      <div class="chatInputs">
        <input class="inputs" v-model="inputMsg" @keyup.enter="sendText" :placeholder="placeholderText"
          :disabled="isSend" @input="InputChange" />
        <el-button class="send boxinput" @click="sendText">
          <img src="@/assets/img/send.png" alt="" />
        </el-button>
        <!-- <el-upload
          :file-list="fileList"
          :on-change="handleChange1"
          action=""
          :http-request="Upload"
          :show-file-list="false"
          accept="text/plain,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        >
          <el-button class="send boxinput mar">
            <img src="@/assets/img/upload.png" alt="" />
          </el-button>
        </el-upload> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { animation } from "@/util/util";
  import {
    getChatMsg,
    chatgpt,
    chatDb,
    chatTool,
    addKnowledge,
    chatImagetext,
    guidanceAnswer,
    healthProgramme
  } from "@/api/getData";
  import aiLogo from "@/assets/img/aiLogo.png";
  import avater_user from "@/assets/img/avatar-user.webp";
  import like from "@/assets/img/like.png";
  import dislike from "@/assets/img/dislike.png";
  import HeadPortrait from "@/components/HeadPortrait";
  import Emoji from "@/components/Emoji";
  import FileCard from "@/components/FileCard.vue";
  import Cookies from "js-cookie";
  import { fetchEventSource } from "@microsoft/fetch-event-source";
  export default {
    components: {
      HeadPortrait,
      Emoji,
      FileCard,
    },
    props: {
      chatWindowInfo: Object,
      default() {
        return {};
      },
      apiInfo: Object,
      innerText: String,
      inputStr: String,
      chatList: Array,
      isRiskAssessment: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      // apiInfo(newval) {
      //   if (newval.key == this.inputMsg) {
      //     this.inputMsg = "";
      //     this.placeholderText = "请输入...";
      //     this.notHaveKey = false;
      //   }
      //   if (newval.key == "") {
      //     this.placeholderText = "请输入用户唯一id";
      //     this.notHaveKey = true;
      //   }
      // },

      innerText: {
        handler(newVal, old) {
          console.log(newVal);
          this.inputMsg = newVal;
        },
        immediate: true,
        deep: true,
      },
      inputStr: {
        handler(newVal, old) {
          this.inputstr = newVal;
        },
        immediate: true,
        deep: true,
      },
    },
    data() {
      return {
        avater_user,
        aiLogo,
        like,
        dislike,
        answerType: 1,
        inputstr: "",
        pdfIcon: require("@/assets/img/pdf_icon.png"),
        wordIcon: require("@/assets/img/word.png"),
        options: [
          {
            value: "1",
            label: "AI大模型",
          },
          {
            value: "2",
            label: "数据库",
          },
        ],
        inputMsg: "",
        showEmoji: false,
        friendInfo: {},
        isSend: false,
        loading: false,
        showLeft: true,
        showRight: true,
        placeholderText: "请输入...",
        notHaveKey: false,
        fileList: [],
        lastScrollTop: 0,
        isUp: false,
        fixMessage: ['请您告诉我您的年龄？', '请您告诉我您的性别？', '您目前的体重和身高是多少呢？'],//前端固定写死的问题
        direction: '',//风险评估方向
      };
    },
    mounted() {
      // if (!Cookies.get("apiInfo") || !JSON.parse(Cookies.get("apiInfo")).key) {
      //   this.placeholderText = "请输入用户唯一id";
      //   this.notHaveKey = true;
      // } else {
      //   this.inputMsg = "";
      //   this.placeholderText = "请输入...";
      //   this.notHaveKey = false;
      // }
    },
    methods: {
      reset() {
        this.inputMsg = "";
        this.isSend = false;
        this.$emit("sendMsg", false);
        this.placeholderText = "请输入...";
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      // 监听会话滚动区域
      handleScroll(event) {
        const container = this.$refs.chatContent; // 获取滚动容器元素

        const currentScrollTop = container.scrollTop; // 当前滚动位置
        // 如果没有初始化过上次滚动位置，或者当前滚动位置小于上次记录的位置，则认为是向上滚动
        if (
          this.lastScrollTop > 0 &&
          this.lastScrollTop - currentScrollTop >= 10
        ) {
          this.isUp = true;
        }
        // 更新上一次滚动位置
        this.lastScrollTop = currentScrollTop;
      },
      Upload() { },
      // 上传文档
      handleChange1(val) {
        if (val.size > 16000000) {
          this.$message.error("文件过大，文件不能超过16M");
          return;
        }

        const formData = new FormData();
        formData.append("file", val.raw);
        formData.append("user_key", this.chatWindowInfo.userKey);
        const loading = this.$loading({
          lock: true,
          text: "拼命上传中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        addKnowledge(formData).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
            loading.close();
          }
        });
      },
      CloseLeft() {
        !this.showLeft ? (this.showLeft = true) : (this.showLeft = false);
        this.$emit("closeLeft", this.showLeft);
      },

      CloseRight() {
        !this.showRight ? (this.showRight = true) : (this.showRight = false);
        this.$emit("closeRight", this.showRight);
      },
      //发送信息
      sendMsg(msgList) {

        this.chatList.push(msgList);
        console.log(this.chatList, "msgList");
        this.isUp = false;
        this.scrollBottom();
      },
      InputChange(val) {
        if (this.inputMsg == "") {
          this.$parent.innerText = "";
        }
      },
      //发送文字信息
      sendText() {
        if (this.inputMsg) {

          let chatMsg = {
            content: this.inputMsg,
            chatType: 0, //信息类型，0文字
            fromType: "Human",
          };

          this.sendMsg(chatMsg);

          this.inputMsg = "";

          this.loading = true;
          let data = {
            prompt: chatMsg.content,
            // user_key: this.chatWindowInfo.userKey,
            session_id: this.chatWindowInfo.sessionId,
          };
          console.log(this.inputstr, "ss");
          if (this.inputstr) {
            data.prompt = this.inputstr;
            data.input = chatMsg.content;
            // data.input = this.inputStr;
          }

          this.isSend = true;
          this.$emit("sendMsg", true);
          let chatGPT = {
            content: "",
            chatType: 0, //信息类型，0文字，1图片
            fromType: "AI", //uid
            id: "",
            liked: null,
            actions: null,
          };
          this.sendMsg(chatGPT);

          if (this.isRiskAssessment) {
            this.sendRiskAssessmentText();
            return;
          }


          // return;
          // 数据库查询
          if (this.answerType == 2) {
            chatDb(data).then((res) => {
              this.loading = false;

              this.showText(
                this.chatList[this.chatList.length - 1],
                res.data.answer,
                res.data.id
              );
            });
            return;
          }
          // 工具库
          if (this.answerType == 3) {
            chatTool(data).then((res) => {
              this.loading = false;
              this.chatList[this.chatList.length - 1].actions = res.data.actions;
              this.showText(
                this.chatList[this.chatList.length - 1],
                res.data.answer,
                res.data.id
              );
            });
            return;
          }
          // 模型查询
          chatgpt(data).then((res) => {
            this.loading = false;
            this.inputstr = "";
            this.showText(
              this.chatList[this.chatList.length - 1],
              res.data.answer,
              res.data.id
            );
          });
        } else {
          this.$message({
            message: "消息不能为空哦~",
            type: "warning",
          });
        }
      },
      // 发送图片
      sendImage(data) {
        let { formData } = data;
        let chatMsg = {
          content: data.prompt,
          img_urls: data.imgs,
          chatType: 1, //信息类型，0文字 1文本图片都有
          fromType: "Human",
        };
        this.sendMsg(chatMsg);
        this.loading = true;
        formData.append("session_id", this.chatWindowInfo.sessionId);

        let chatGPT = {
          content: "",
          chatType: 0, //信息类型，0文字，1图片
          fromType: "AI", //uid
          id: "",
          liked: null,
          actions: null,
        };
        this.sendMsg(chatGPT);
        this.isSend = true;
        this.$emit("sendMsg", true);
        // 模型查询
        chatImagetext(formData).then((res) => {
          this.loading = false;
          this.showText(
            this.chatList[this.chatList.length - 1],
            res.data.answer,
            res.data.id
          );
        });
      },
      // 发送报告
      sendReport(data) {
        let { file } = data;
        const tmpcnt = file.name.lastIndexOf(".");
        const exname = file.name.substring(tmpcnt + 1);
        let size = (file.size / 1024 / 1024).toFixed(2);
        let fileTypes = ["pdf", "doc", "docx"];
        if (fileTypes.indexOf(exname) < 0)
          return ElMessage.warning("不支持的格式，请重新上传");
        let chatMsg = {
          name: file.name.substring(0, tmpcnt),
          size,
          exname,
          chatType: 2, //信息类型，0文字
          fromType: "Human",
        };
        this.sendMsg(chatMsg);
        this.loading = true;
        this.$emit("sendMsg", true);
        let chatGPT = {
          content: "",
          chatType: 0, //信息类型，0文字，1图片
          fromType: "AI", //uid
          id: "",
          liked: null,
          actions: null,
        };
        this.sendMsg(chatGPT);
        this.isSend = true;

        let formData = new FormData();
        formData.append("file", file);
        this.sendReportMessage(formData);
      },
      sendReportMessage(data) {
        let _that = this;
        let url = `https://ai.vvmedic.com/gov-beta/api/report/analysis/process`;
        fetchEventSource(url, {
          method: "POST",
          body: data,
          openWhenHidden: true,
          onmessage(event) {
            if (event.data) {
              let reponse = event.data;
              _that.showMsg(reponse, _that.chatList[_that.chatList.length - 1]);
            }
          },
          onclose(event) {
            // showOptionsBtn
            _that.isSend = false;
            // _that.$emit("answerComplete", data.question);
            _that.$emit("sendMsg", false);
          },
          onerror(error) {
            _that.isSend = false;
            _that.loading = false;
            throw error;
          },
        });
      },
      // 发送风险评估
      sendRiskAssessment(data) {
        this.direction = data.name || '';
        let chatMsg = {
          content: data.text,
          chatType: 0, //信息类型，0文字 1文本图片都有
          fromType: "Human",
        };
        this.sendMsg(chatMsg);
        let chatGPT = {
          content: "",
          chatType: 0, //信息类型，0文字，1图片
          fromType: "AI", //uid
          id: "",
        };
        this.sendMsg(chatGPT);
        this.sendRiskAssessmentText();
      },
      // 风险评估消息发送
      sendRiskAssessmentText() {
        //   自己回答
        let l = this.fixMessage.length;
        if (this.chatList.length < l * 2 + 2) {
          let text = '';
          let index = -1;
          if (this.chatList.length > 2) {
            text = this.chatList[this.chatList.length - 3].content;
            index = this.fixMessage.indexOf(text);
          }
          let chatMsg = {
            content: this.fixMessage[index + 1],
            chatType: 0, //信息类型，0文字 1文本图片都有
            fromType: "Ai",
          };
          this.loading = false;
          this.showText(
            this.chatList[this.chatList.length - 1],
            this.fixMessage[index + 1],
            0
          );
        } else {
          let data = [];
          this.chatList.map((item) => {
            if (item.content) {
              data.push({
                role: item.fromType,
                content: item.content,
              });
            }

          });
          let request = guidanceAnswer;
          let params = {
            direction: this.direction,
            data: data,
          }
          if (this.direction == 'healthPlan') {
            request = healthProgramme;
            params = data
          }
          request(params).then((res) => {
            if (res.code == 200 && res.data) {
              this.loading = false;
              this.showText(
                this.chatList[this.chatList.length - 1],
                res.data.answer,
                0
              );
            }
          });
        }
      },

      // 显示返回消息
      showMsg(eventObj, obj) {
        this.loading = false;
        this.$set(obj, "content", obj.content + eventObj);
        this.scrollBottom();
      },
      // 文字逐个显示
      showText(obj, text, id) {
        this.currentIndex = 0;
        const fullText = text;
        const interval = 80;
        // 定时器逐个显示文字
        this.timer = setInterval(() => {
          if (!obj) {
            clearInterval(this.timer);
            return (this.timer = null);
          }
          obj.content = fullText.substring(0, this.currentIndex + 1); // 更新显示的文字内容
          this.currentIndex++;
          if (!this.isUp) this.scrollBottom();

          if (this.currentIndex === fullText.length) {
            clearInterval(this.timer);
            this.isSend = false;
            this.$emit("sendMsg", false);
            obj.id = id;
            this.isUp = false;
            // 完成回答
            this.$emit("answerComplete");
          }
        }, interval);
      },

      // 点赞  点踩
      isLikeFun(index, val) {
        console.log(index);
        console.log(val);
        this.$emit("isLikedFun", index, val);
      },

      optionsClick(val) {
        console.log(val, "val");
      },

      //获取窗口高度并滚动至最底层
      scrollBottom() {
        this.$nextTick(() => {
          const scrollDom = this.$refs.chatContent;
          animation(scrollDom, scrollDom.scrollHeight - scrollDom.offsetHeight);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .flash_cursor {
    width: 8px;
    height: 24px;
    display: inline-block;
    background: #d6e3f5;
    opacity: 1;
    animation: glow 800ms ease-out infinite alternate;
  }

  @keyframes glow {
    0% {
      opacity: 1;
    }

    25% {
      opacity: 0.5;
    }

    50% {
      opacity: 0;
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }

  .chat-window {
    width: 100%;
    height: 100%;
    margin-left: 20px;
    position: relative;
    // padding-bottom: 40px;
    box-sizing: border-box;

    .top {
      margin-bottom: 50px;

      &::after {
        content: "";
        display: block;
        clear: both;
      }

      .head-pic {
        float: left;
      }

      .info-detail {
        float: left;
        margin: 5px 20px 0;

        .name {
          font-size: 20px;
          font-weight: 600;
          color: #fff;
        }

        .detail {
          color: #9e9e9e;
          font-size: 12px;
          margin-top: 2px;
        }
      }

      .other-fun {
        float: right;
        margin-top: 20px;

        span {
          margin-left: 30px;
          cursor: pointer;
        }

        // .icon-tupian {

        // }
        input {
          display: none;
        }
      }
    }

    .topMsg {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #444654;
      color: #e5e5e5;
      font-size: 14px;
      padding: 0px 12px;
      box-sizing: border-box;

      .iconSize {
        font-size: 20px;
        display: flex;
        align-items: center;
        width: 33%;

        .modeType {
          font-size: 16px;
          margin-left: 20px;
          color: #fff;
          flex-shrink: 0;
        }
      }

      .iconSize:last-child {
        justify-content: flex-end;
      }

      .iconBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33%;

        .logo {
          width: 36px;
          height: 36px;
          margin-right: 10px;
        }
      }
    }

    .botoom {
      width: 100%;
      height: calc(100vh - 100px);
      background-color: rgb(50, 54, 68);

      // padding: 20px;
      box-sizing: border-box;
      // position: relative;

      .chat-content {
        width: 100%;
        height: 90%;
        overflow-y: scroll;
        // padding: 20px;
        box-sizing: border-box;

        &::-webkit-scrollbar {
          width: 0;
          /* Safari,Chrome 隐藏滚动条 */
          height: 0;
          /* Safari,Chrome 隐藏滚动条 */
          display: none;
          /* 移动端、pad 上Safari，Chrome，隐藏滚动条 */
        }

        .chat-wrapper {
          position: relative;
          word-break: break-all;

          .chat-friend {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            background-color: rgb(57 62 83);
            color: rgb(243 244 246);
            padding: 24px 20%;
            box-sizing: border-box;

            .chatLine {
              flex: 1;

              .optionsBox {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                background-color: rgb(52 57 76);
                font-size: 14px;
                padding: 8px 12px;
                border-radius: 22px;
                float: right;
                margin-top: 10px;

                .text {
                  margin-right: 10px;
                }

                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 15px;
                  cursor: pointer;
                }

                img:last-child {
                  margin-right: 0px;
                }
              }
            }

            .chat-text {
              flex: 1;
              color: #fff;
              line-height: 24px;
              position: relative;
              flex-shrink: 0;
              font-size: 16px;
              overflow: hidden;

              pre {
                white-space: break-spaces;
              }
            }

            .chat-img {
              img {
                width: 100px;
                height: 100px;
              }
            }

            .info-time {
              // margin: 10px 0;
              color: #fff;
              font-size: 14px;

              img {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                vertical-align: middle;
                margin-right: 10px;
              }

              span:last-child {
                color: rgb(101, 104, 115);
                margin-left: 10px;
                vertical-align: middle;
              }
            }
          }

          .chat-me {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: flex-start;
            padding: 24px 20%;
            box-sizing: border-box;

            .chat-text {
              background-color: rgb(50, 54, 68);
              color: #fff;
              flex: 1;
              line-height: 24px;
              font-size: 16px;
              overflow: hidden;

              pre {
                white-space: break-spaces;
              }
            }

            .imgWrap {
              display: flex;
              flex-wrap: wrap;

              .img {
                width: 80px;
                height: 80px;
                margin: 0 10px 10px 0;
              }
            }

            .chat-img {
              img {
                max-width: 300px;
                max-height: 200px;
                border-radius: 10px;
              }
            }

            .info-time {
              color: #fff;
              font-size: 14px;
              display: flex;
              justify-content: flex-end;
              align-items: flex-start;

              img {
                width: 24px;
                height: 24px;
                vertical-align: middle;
                margin-right: 10px;
              }

              span {
                line-height: 30px;
              }

              span:first-child {
                color: rgb(101, 104, 115);
                margin-right: 10px;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }

  .chatInputs {
    width: 90%;
    position: absolute;
    bottom: 0;
    margin: 3%;
    display: flex;
    // align-items: center;
    // justify-content: center;
    font-size: 16px;

    .boxinput {
      width: 50px;
      height: 50px;
      background-color: rgb(66, 70, 86);
      border-radius: 15px;
      border: 1px solid rgb(80, 85, 103);
      position: relative;
      cursor: pointer;
      box-shadow: 0 5px 20px rgba(52, 53, 65, 0.8);

      img {
        width: 30px;
        height: 30px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .mar {
      margin-left: 20px;
    }

    .emoji {
      transition: 0.3s;

      &:hover {
        background-color: rgb(46, 49, 61);
        border: 1px solid rgb(71, 73, 82);
      }
    }

    .inputs {
      width: 90%;
      height: 50px;
      background-color: rgb(66, 70, 86);
      border-radius: 15px;
      border: 2px solid rgb(66, 70, 86);
      padding: 10px;
      box-sizing: border-box;
      transition: 0.2s;
      font-size: 16px;
      color: #fff;
      font-weight: 100;
      margin: 0 20px;

      &:focus {
        outline: none;
      }
    }

    .send {
      background-color: rgba(72, 101, 255, 0.8);
      border: 0;
      transition: 0.3s;
      box-shadow: 0px 0px 5px 0px rgba(72, 101, 255, 0.8);

      &:hover {
        box-shadow: 0px 0px 10px 0px rgba(72, 101, 255, 0.8);
      }
    }
  }

  .flex {
    display: flex;
  }

  .flex1 {
    flex: 1;
  }

  .over-hide1 {
    overflow: hidden;
  }

  .font-m {
    font-weight: 500;
  }

  .eils {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>